import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _batchEmailInviteRequest = {};
var _batchEmailInviteResponse = {};
var _emailInviteLinkRequest = {};
var _emailInviteLinkResponse = {};
var _emailInviteRequest = {};
var _empty = {};
function resolveWixSocialGroupsApiV1SocialGroupsInviteServiceUrl(opts) {
    var domainToMappings = {
        'api._api_base_domain_': [
            {
                srcPath: '/social-groups-invites-proxy',
                destPath: '',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/social-groups-proxy/social-groups-invites',
                destPath: '',
            },
        ],
        _: [
            {
                srcPath: '/_api/social-groups-proxy/social-groups-invites',
                destPath: '',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/social-groups-proxy/social-groups-invites',
                destPath: '',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/social-groups-proxy/social-groups-invites',
                destPath: '',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/social-groups-proxy/social-groups-invites',
                destPath: '',
            },
        ],
        'editor.wixapps.net': [
            {
                srcPath: '/_api/social-groups-proxy/social-groups-invites',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/social-groups-proxy/social-groups-invites',
                destPath: '',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/social-groups-proxy/social-groups-invites',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
export function inviteByEmail(payload) {
    var _a = serializer(_emailInviteRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_empty, {}).fromJSON;
    function __inviteByEmail(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.social_groups.v1.email_invite',
            method: 'POST',
            methodFqn: 'wix.social.groups.api.v1.SocialGroupsInviteService.inviteByEmail',
            url: resolveWixSocialGroupsApiV1SocialGroupsInviteServiceUrl({
                protoPath: '/api/v1/groups/{groupId}/invites/email',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __inviteByEmail.fromReq = fromReq;
    __inviteByEmail.__isAmbassador = true;
    return __inviteByEmail;
}
export function batchInviteByEmail(payload) {
    var _a = serializer(_batchEmailInviteRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_batchEmailInviteResponse, {}).fromJSON;
    function __batchInviteByEmail(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.social_groups.v1.email_invite',
            method: 'POST',
            methodFqn: 'wix.social.groups.api.v1.SocialGroupsInviteService.batchInviteByEmail',
            url: resolveWixSocialGroupsApiV1SocialGroupsInviteServiceUrl({
                protoPath: '/api/v1/groups/{groupId}/invites/email-batch',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __batchInviteByEmail.fromReq = fromReq;
    __batchInviteByEmail.__isAmbassador = true;
    return __batchInviteByEmail;
}
export function inviteLink(payload) {
    var _a = serializer(_emailInviteLinkRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_emailInviteLinkResponse, {}).fromJSON;
    function __inviteLink(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.social_groups.v1.email_invite',
            method: 'GET',
            methodFqn: 'wix.social.groups.api.v1.SocialGroupsInviteService.inviteLink',
            url: resolveWixSocialGroupsApiV1SocialGroupsInviteServiceUrl({
                protoPath: '/api/v1/groups/{groupId}/invites/email',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __inviteLink.fromReq = fromReq;
    __inviteLink.__isAmbassador = true;
    return __inviteLink;
}
//# sourceMappingURL=http.impl.js.map